<div
  class="relative flex flex-col justify-center w-full gap-4 py-10 mb-10 lg:gap-0 statistic 2lg:w-3/12 2lg:py-0 2lg:mb-0"
>
  <img src="assets/svg/ea-bg.svg" alt="Educação Adventista" class="absolute z-0 w-full h-full" />
  <div class="relative z-10 text-6xl statistic__title">
    {{ 'global.adventist-education' | translate }}
  </div>
  <div class="relative z-10 text-6xl statistic__subtitle">
    {{ 'statistics.title' | translate }}
  </div>
</div>

<div class="relative flex flex-col items-start w-full gap-10 md:items-center lg:items-start lg:w-auto">
  <img
    src="assets/svg/mapa-mundo.svg"
    alt="Educação Adventista"
    class="absolute z-0 hidden w-full lg:block lg:w-auto lg:h-full lg:left-44 xl:left-52"
  />
  <app-card-statistic-background-image *ngFor="let statistic of statistics$ | async" [data]="statistic">
  </app-card-statistic-background-image>
</div>
